export { BonusesContent } from './BonusesContentHOC';
